import Vue from 'vue'
import Vuex from 'vuex'
import firebaseApp from '@/classes/Db'
import spots from '@/json/spots_update.json'
import areas from '@/json/new_areas.json'
import objectsJson from '@/json/objects.json'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    showMenu: false,
    user: null,
    userCheck: false,
    userLocation: {
      lat: 59.334591,
      lng: 18.063240
    },
    needsReload: false,
    userPhotos: [],
    userScore: null,
    locationError: false,
    userNotices: [],
    userNoticesRead: true,
    showAuth: true,
    showLogin: true,
    showingPhotoUpload: false,
    points: 0,
    spots: [],
    visitedSpots: [],
    areas: [],
    currentArea: null,
    currentAreaName: null,
    atSpot: [null, 0],
    atSpotPhotos: [],
    atSpotPhotosLoaded: false,
    atSpotWinner: null,
    uploadingPhoto: false,
    waiting: [],
    battleWinner: null,
    uploadingPhotoProgress: 0,
    interupt: null,
    singlePhoto: null,
    infoMenu: false,
    bugReport: false,
    textPageContent: null,
    voteOnPhoto: null,
    highscore: null,
    highscoreList: null,
    justVoted: 'no',
    userVisitedSpots: [],
    threeDObjects: [],
    showAgreement: false,
    hasBeenToStart: false,
    wasAtAr: false,
    locationHasBeenLoaded: false,
    spotAtDistance: null
  },
  getters: {
    showingOverlay: (state) => {
      return (state.atSpot[0] !== null)
    },
    fullScore: (state) => {
      return state.userScore + (state.userVisitedSpots.length * 10)
    },
    userHasPhotoAtSpot: (state) => {
      let photos = state.userPhotos
      let spot = state.atSpot
      let userphoto = photos.filter((a) => {
        if (a.spot === spot[0]) {
          return true
        }
        return false
      })
      return userphoto.length > 0
    }
  },
  mutations: {
    setNeedsReload (state, needs) {
      state.needsReload = needs
    },
    updateSpotAtDistance (state, show) {
      state.spotAtDistance = show
    },
    setLocationHasBeenLoaded (state, show) {
      state.locationHasBeenLoaded = show
    },
    setWasAtAr (state, show) {
      state.wasAtAr = show
    },
    setHasBeenToStart (state, show) {
      state.hasBeenToStart = show
    },
    setShowAgreement (state, show) {
      state.showAgreement = show
    },
    updateHighscore (state, list) {
      state.highscoreList = list
    },
    updateUserVisitedSpots (state, spots) {
      state.userVisitedSpots = spots
    },
    importThreeDObjects (state, objs) {
      state.threeDObjects = objectsJson
    },
    setUserScore (state, score) {
      state.userScore = score
    },
    setUserPhotos (state, photos) {
      state.userPhotos = photos
    },
    setJustVoted (state, what) {
      state.justVoted = what
    },
    showHighscore (state, show) {
      state.highscore = show
    },
    updateVoteOnPhoto (state, photo) {
      state.voteOnPhoto = photo
    },
    openTextPage (state, html) {
      state.textPageContent = html
    },
    changeShowMenu (state, at) {
      state.showMenu = at
    },
    showBugReport (state, show) {
      state.bugReport = show
    },
    changeUserLocation (state, location) {
      state.userLocation = location
    },
    changeLocationError (state, hasError) {
      state.locationError = hasError
    },
    showAuth (state, show) {
      state.showAuth = show
    },
    showLogin (state, show) {
      state.showLogin = show
    },
    setSinglePhoto (state, photo) {
      state.singlePhoto = photo
    },
    showInfoMenu (state, show) {
      state.infoMenu = show
    },
    showingPhotoUpload (state, show) {
      state.showingPhotoUpload = show
    },
    updateUser (state, user) {
      state.user = user
    },
    updateUserCheck (state, userCheck) {
      state.userCheck = userCheck
    },
    setCurrentArea (state, areaKey) {
      state.currentArea = areaKey
    },
    setCurrentAreaName (state, areaName) {
      state.currentAreaName = areaName
    },
    setAtSpot (state, spotname) {
      state.atSpot = spotname
    },
    setAtSpotWinner (state, winner) {
      state.atSpotWinner = winner
    },
    setBattleWinner (state, winner) {
      state.battleWinner = winner
    },
    setAtSpotPhotos (state, spotPhotos) {
      state.atSpotPhotos = spotPhotos
    },
    setAtSpotPhotosLoaded (state, bol) {
      state.atSpotPhotosLoaded = bol
    },
    addAtSpotPhotos (state, photo) {
      state.atSpotPhotos.push(photo)
    },
    addNewWaiting (state, waitingPhoto) {
      state.waiting.push(waitingPhoto)
    },
    updateWaiting (state, waitingPhoto) {
      state.waiting = state.waiting.map((a, index) => {
        if (index === waitingPhoto.key) {
          return waitingPhoto.val
        } else {
          return a
        }
      })
    },
    updateNotices (state, notices) {
      state.userNotices = notices
    },
    logout (state) {
      state.user = null
    },
    interupt (state, obj) {
      state.interupt = obj
    }
  },
  actions: {
    viewSinglePhoto (context, payload) {
      context.commit('setSinglePhoto', payload)
    },
    setAtSpot (context, payLoad) {
      context.commit('setAtSpot', [payLoad.spotname, payLoad.distance])
      //  Get photos from spot if not null
      if (payLoad.spotname !== null) {
        firebaseApp.database().ref('/photos/' + context.state.atSpot[0]).orderByChild('score').limitToLast(29).once('value').then((snapshot) => {
          var photos = []
          snapshot.forEach((childSnapshot) => {
            let val = childSnapshot.val()
            photos.push({
              filename: val.filename,
              time: val.time,
              url: val.url,
              thumburl: val.thumburl,
              user: val.user,
              username: val.username,
              score: val.score,
              voteCount: val.voteCount
            })
          })
          context.commit('setAtSpotPhotos', photos)
          context.commit('setAtSpotPhotosLoaded', true)
        })
        context.dispatch('fetchWinner')
      } else {
        context.commit('setAtSpotPhotos', [])
        context.commit('setAtSpotWinner', null)
        context.commit('setAtSpotPhotosLoaded', false)
      }
    },
    reportABug (context, payLoad) {
      let report = {
        text: payLoad.text,
        user: context.state.user.displayName,
        userid: context.state.user.uid,
        time: {'.sv': 'timestamp'}
      }
      let newReport = firebaseApp.database().ref('reports/').push()
      newReport.set(report)
      context.commit('interupt', 'Tack!')
      context.commit('showBugReport', false)
    },
    fetchfromApi (context) {
      console.log('test')
    },
    logout (context) {
      firebaseApp.auth().signOut().then(() => {
        context.commit('logout')
        window.setTimeout(() => {
          window.location.reload()
        }, 2000)
      }).catch((error) => {
        console.log('Någonting gick fel när du loggades ut: ', error)
      })
    },
    uploadPhoto (context, payLoad) {
      //  console.log('uploading phot from store', payLoad.file)
      let storageRef = firebaseApp.storage().ref()
      let photoId = payLoad.fileName + Math.floor(Date.now() / 1000)
      let uploadTask = storageRef.child('photos/' + photoId).put(payLoad.file)
      context.state.uploadingPhoto = true
      uploadTask.on('state_changed', (snapshot) => {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        context.state.uploadingPhotoProgress = progress
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused')
            break
          case 'running':
            break
        }
      }, (error) => {
        context.state.uploadingPhoto = false
        switch (error.code) {
          case 'storage/unauthorized':
            console.log('unauthorized to upload image')
            break
          case 'storage/canceled':
            console.log('User canceled upload image')
            break
          case 'storage/unknown':
            console.log('Unknown error')
            break
        }
      }, () => {
        //  Upload thumnnail then save in db
        let uploadThumbTask = storageRef.child('thumbs/' + payLoad.fileName).put(payLoad.thumb)
        uploadThumbTask.on('state_changed', (snapshotThumb) => {
        }, (error) => {
          switch (error.code) {
            case 'storage/unauthorized':
              console.log('unauthorized to upload thumb image')
              break
            case 'storage/canceled':
              console.log('User canceled upload thumb image')
              break
            case 'storage/unknown':
              console.log('Unknown error, thumb image')
              break
          }
        }, () => {
          //  console.log('uploading thumb done')
          context.state.uploadingPhoto = false
          let downloadUrl = uploadTask.snapshot.downloadURL
          let thumbUrl = uploadThumbTask.snapshot.downloadURL
          //  console.log(downloadUrl)
          //  Perhaps check if atSpot exists first & user is logged in
          //  Save ref in database user/photos and photos/spot

          //  Delete any old photos from spot

          if (payLoad.isFirst === true) {
            context.commit('interupt', { html: 'Snyggt! Ditt foto är med i Exhibition Stockholm<h6>Så fort minst fem personer har röstat på din bild är den med och tävlar.</h6><h5>+20 poäng</h5>', type: 'win' })
          } else {
            context.commit('interupt', { html: 'Du har bytt ut ditt foto!<h6>Så fort minst fem personer har röstat på ditt nya foto är den med och tävlar.</h6>', type: 'win' })
          }

          firebaseApp.database().ref('photos/' + context.state.atSpot[0] + '/' + photoId).set({
            user: context.state.user.uid,
            username: context.state.user.displayName,
            filename: payLoad.fileName,
            id: photoId,
            url: downloadUrl,
            thumburl: thumbUrl,
            spot: context.state.atSpot[0],
            time: {'.sv': 'timestamp'}
          })
          firebaseApp.database().ref('users/' + context.state.user.uid + '/photos/' + photoId).set({
            filename: payLoad.fileName,
            url: downloadUrl,
            id: photoId,
            thumburl: thumbUrl,
            spot: context.state.atSpot[0],
            user: context.state.user.uid,
            username: context.state.user.displayName
          })
          firebaseApp.database().ref('votes/' + photoId + '/' + context.state.user.uid).set({
            like: 1,
            time: {'.sv': 'timestamp'},
            spot: context.state.atSpot[0]
          })
          firebaseApp.database().ref('votes/' + photoId + '/spot').set(context.state.atSpot[0])
          //  Add local
          context.commit('addAtSpotPhotos', {
            user: context.state.user.uid,
            username: context.state.user.displayName,
            filename: payLoad.fileName,
            url: downloadUrl,
            id: photoId,
            thumburl: thumbUrl,
            time: {'.sv': 'timestamp'}
          })
          //  Photo upload done.
          context.dispatch('addNotice', {
            text: 'Du laddade upp ett foto till ' + context.state.atSpot[0],
            user: context.state.user.uid,
            type: 'win'
          })
          window.setTimeout(() => {
            context.state.showingPhotoUpload = false
          }, 1000)
        })
      })
    },
    startGettingNotices (context) {
      let notices = firebaseApp.database().ref('notices/' + context.state.user.uid).orderByChild('time').limitToLast(10)
      notices.on('value', (snapshot) => {
        let noticeArray = []
        snapshot.forEach((childSnapshot) => {
          var val = childSnapshot.val()
          noticeArray.push(val)
        })
        context.commit('updateNotices', noticeArray)
      })
    },
    fetchUserVisitedSpots (context) {
      let ref = firebaseApp.database().ref('visitedspots/' + context.state.user.uid)
      ref.on('value', (snapshot) => {
        let visitedspots = []
        snapshot.forEach((childSnapshot) => {
          var val = childSnapshot.val()
          visitedspots.push(val)
        })
        context.commit('updateUserVisitedSpots', visitedspots)
      })
    },
    fetchAllSpotsForUser (context) {
      let ref = firebaseApp.database().ref('spots')
      ref.once('value', (snapshot) => {
        let visitedspots = []
        snapshot.forEach((childsnap) => {
          childsnap.forEach((spot) => {
            visitedspots.push(spot.val())
          })
        })
        context.commit('updateUserVisitedSpots', visitedspots)
      })
      console.log('Laddar in alla spots till användaren')
    },
    addUserVisitedSpot (context, payLoad) {
      if (context.state.user.uid === null) {
        return
      }
      let visitedspots = context.state.userVisitedSpots.slice()
      for (var i = 0; i < visitedspots.length; i++) {
        if (visitedspots[i].name === payLoad.spot) {
          //  console.log('Exists in uservisiste')
          return
        }
      }
      //  Interupt
      context.commit('interupt', { html: 'Du har hittat en ny fotoplats!<h6>Utforska, var kreativ och ta ett foto inom vid denna plats för att vara med och tävla och få möjligheten att tjäna fler poäng. Se andras bilder för inspiration!</h6><h5>+10 poäng</h5>', type: 'win' })
      let ref = firebaseApp.database().ref('spots/' + payLoad.areaKey + '/' + payLoad.spot)
      ref.once('value').then((snapshot) => {
        let toSet = snapshot.val()
        firebaseApp.database().ref('visitedspots/' + context.state.user.uid + '/' + payLoad.spot).set(toSet)
      })
    },
    fetchUserPhotosAndScore (context) {
      //  console.log('fetching score & photos')
      let ref = firebaseApp.database().ref('users/' + context.state.user.uid + '/photos/')
      ref.on('value', (snapshot) => {
        let photoArray = []
        let score = 0
        snapshot.forEach((childSnapshot) => {
          var val = childSnapshot.val()
          photoArray.push(val)
          if (val.score) {
            score = score + 20 + val.score
          } else {
            score = score + 20
          }
        })
        context.commit('setUserScore', score)
        context.commit('setUserPhotos', photoArray)
      })
    },
    fetchHighscore (context) {
      let ref = firebaseApp.database().ref('highscore')
      ref.on('value', (snapshot) => {
        let highscore = []
        snapshot.forEach((childSnapshot) => {
          var val = childSnapshot.val()
          highscore.push({
            user: childSnapshot.key,
            score: val.score,
            username: val.name
          })
        })
        context.commit('updateHighscore', highscore)
      })
    },
    addNotice (context, payLoad) {
      let notice = {
        user: payLoad.user,
        text: payLoad.text,
        type: payLoad.type,
        read: true,
        time: {'.sv': 'timestamp'}
      }
      let newNotice = firebaseApp.database().ref('notices/' + payLoad.user).push()
      newNotice.set(notice)
    },
    fetchWinner (context, payLoad) {
      firebaseApp.database().ref('winner/' + context.state.atSpot[0]).once('value').then((snapshot) => {
        let winner = null
        winner = snapshot.val()
        if (winner === null) {
          //  console.log('no winner at spot')
        } else {
          //  console.log('Winner at spot:', winner)
          context.commit('setAtSpotWinner', winner)
        }
      })
    },
    castVoteFor (context, payLoad) {
      let voteObj = {
        user: context.state.user.uid,
        username: context.state.user.displayName,
        contestant: payLoad.contestant,
        winner: payLoad.winner,
        time: {'.sv': 'timestamp'}
      }
      //  Is this the winning vote?
      if ('votes' in payLoad.battle && 'against' in payLoad.battle.votes && payLoad.battle.votes.against.length > 1) {
        console.log('we have a winner!!!!')
        //  commmit('make waiter a winner and set winner to false')
      }
      //  update local
      //  update remote
      firebaseApp.database().ref('waiting/' + payLoad.contestant + '/votes/for/' + context.state.user.uid).set(voteObj)
      firebaseApp.database().ref('waiting/' + payLoad.contestant + '/winner').set(payLoad.winner)
      context.dispatch('addNotice', {
        text: 'Someone voted for your photo at ' + payLoad.battle.spot,
        user: payLoad.battle.user,
        type: 'challange'
      })
    },
    castVoteAgainst (context, payLoad) {
      let voteObj = {
        user: context.state.user.uid,
        username: context.state.user.displayName,
        contestant: payLoad.contestant,
        winner: payLoad.winner,
        time: {'.sv': 'timestamp'}
      }
      //  Is this the winning vote?
      if ('votes' in payLoad.battle && 'against' in payLoad.battle.votes && payLoad.battle.votes.against.length > 1) {
        console.log('we have a winner!')
        //  commmit('make winner a winner and remove waiter')
      }
      //  update local
      //  update remote
      firebaseApp.database().ref('waiting/' + payLoad.contestant + '/votes/against/' + context.state.user.uid).set(voteObj)
      firebaseApp.database().ref('waiting/' + payLoad.contestant + '/winner').set(payLoad.winner)
      context.dispatch('addNotice', {
        text: 'Someone voted against your photo at ' + payLoad.battle.spot,
        user: payLoad.battle.user,
        type: 'challange'
      })
    },
    fetchBattleWinner (context, payLoad) {
      firebaseApp.database().ref('winners/' + payLoad.spot).orderByChild('time').limitToLast(1).once('value').then((snapshot) => {
        let winner = null
        snapshot.forEach((childSnapshot) => {
          winner = childSnapshot.val()
        })
        if (winner === null) {
          console.log('no winner at spot to battle')
        } else {
          //  console.log('Winner at spot:', winner)
          context.commit('setBattleWinner', winner)
        }
      })
    },
    makeWinner (context, payLoad) {
      console.log('Making a winner', payLoad.contestant)
      let contestant = payLoad.contestant
      let photoObj = {
        user: contestant.user,
        username: contestant.username,
        firstAtSpot: true,
        url: contestant.url,
        thumburl: contestant.thumburl,
        filename: contestant.filename,
        time: {'.sv': 'timestamp'}
      }
      firebaseApp.database().ref('winners/' + contestant.spot + '/' + contestant.filename).set(photoObj)
      context.commit('setAtSpotWinner', photoObj)
    },
    fetchAreasFromApi (context) {
      firebaseApp.database().ref('areas').once('value').then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          let val = childSnapshot.val()
          //  save areas with lat lng
          context.state.areas.push({
            key: childSnapshot.key,
            name: val.name,
            coordinates: val.coordinates
          })
        })
      })
    },
    populateAreas (context, payload) {
      /* var frihamnen = [{lng: 18.115854, lat: 59.347064},
        {lng: 18.111992, lat: 59.346626},
        {lng: 18.109932, lat: 59.345489},
        {lng: 18.111048, lat: 59.343826},
        {lng: 18.112593, lat: 59.342425},
        {lng: 18.114824, lat: 59.340937},
        {lng: 18.117142, lat: 59.339887},
        {lng: 18.118601, lat: 59.339668},
        {lng: 18.122635, lat: 59.339493},
        {lng: 18.125381, lat: 59.339799},
        {lng: 18.128042, lat: 59.340412},
        {lng: 18.128986, lat: 59.342250},
        {lng: 18.131218, lat: 59.345751},
        {lng: 18.128986, lat: 59.346539},
        {lng: 18.125725, lat: 59.346758},
        {lng: 18.124352, lat: 59.346233},
        {lng: 18.118773, lat: 59.345445},
        {lng: 18.116283, lat: 59.345883},
        {lng: 18.115854, lat: 59.347064}] */
      /* var danderyd = [{lng: 17.995434, lat: 59.413907},
        {lng: 18.013630, lat: 59.420282},
        {lng: 18.035774, lat: 59.418361},
        {lng: 18.052597, lat: 59.412334},
        {lng: 18.057232, lat: 59.393374},
        {lng: 18.044701, lat: 59.385420},
        {lng: 18.023243, lat: 59.384108},
        {lng: 18.005047, lat: 59.385944},
        {lng: 17.982044, lat: 59.408229},
        {lng: 17.992859, lat: 59.413120},
        {lng: 17.995434, lat: 59.413907}] */
      /* var stureplan = [{lng: 18.07723, lat: 59.33236},
        {lng: 18.07547, lat: 59.33289},
        {lng: 18.07371, lat: 59.33437},
        {lng: 18.06847, lat: 59.33415},
        {lng: 18.06744, lat: 59.33588},
        {lng: 18.06856, lat: 59.33801},
        {lng: 18.07032, lat: 59.34214},
        {lng: 18.07699, lat: 59.34113},
        {lng: 18.08281, lat: 59.33932},
        {lng: 18.08161, lat: 59.33748},
        {lng: 18.0798, lat: 59.33452}] */

      /* firebaseApp.database().ref('areas/frihamnen').set({
        name: 'Frihamnen',
        coordinates: frihamnen
      }) */
      /* firebaseApp.database().ref('areas/ostermalm').set({
        name: 'Östermalm',
        coordinates: stureplan
      }) */
    },
    populateAreasFromJson (context, payLoad) {
      console.log(areas.features)
      areas.features.forEach((yta) => {
        let temp = yta.geometry.coordinates[0].map((a, index) => {
          return { lng: a[0], lat: a[1] }
        })
        firebaseApp.database().ref('areas/' + yta.properties.key).set({
          name: yta.properties.name,
          coordinates: temp
        })
      })
    },
    populateSpots () {
      spots.forEach((area) => {
        area.spots.forEach((spot) => {
          firebaseApp.database().ref('spots/' + area.key + '/' + spot.name).set({
            'name': spot.name,
            'coordinates': {
              'lat': spot.lat,
              'lng': spot.lng
            }
          })
        })
        console.log(area)
      })
    },
    fetchSpots (context, payload) {
      //  console.log('getting spots for ' + payload.areaKey)
      firebaseApp.database().ref('spots/' + payload.areaKey).once('value').then((snapshot) => {
        context.state.spots = []
        snapshot.forEach((childSnapshot) => {
          var val = childSnapshot.val()
          //  console.log('Fetching this spot: ', val)
          firebaseApp.database().ref('winner/' + val.name).once('value').then((snapshotWinner) => {
            let winner = null
            winner = snapshotWinner.val()
            context.state.spots.push({
              key: childSnapshot.key,
              name: val.name,
              coordinates: val.coordinates,
              winner: winner
            })
          })
        })
      })
    },
    startVoting (context) {
      if (context.state.user === null) {
      } else {
        let voteOnMe = firebaseApp.database().ref('votes').orderByChild(context.state.user.uid).equalTo(null).limitToFirst(1)
        voteOnMe.on('value', (snapshot) => {
          let photoInfo = null
          let photoId = null
          if (snapshot.val() === null) {
            context.commit('updateVoteOnPhoto', 0)
          } else {
            snapshot.forEach((snapshotObj) => {
              photoInfo = snapshotObj.val()
              //  console.log('photo', photoInfo)
              photoId = snapshotObj.key
              firebaseApp.database().ref('photos/' + photoInfo.spot + '/' + photoId).once('value').then((snapshotToVoteOn) => {
                let photoToVoteOn = snapshotToVoteOn.val()
                context.commit('updateVoteOnPhoto', photoToVoteOn)
              })
            })
          }
        })
      }
    },
    vote (context, payLoad) {
      //  console.log('voted on', payLoad)
      firebaseApp.database().ref('votes/' + payLoad.photoId + '/' + context.state.user.uid).set({
        like: payLoad.score,
        spot: payLoad.spot,
        time: {'.sv': 'timestamp'}
      })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js